import { jsx as m } from "react/jsx-runtime";
import c from "clsx";
import { forwardRef as e } from "react";
import '../../_assets/IconButton.Bq_e0rWp.css';const l = "_root_175rw_44", p = {
  root: l
}, f = e(
  ({ disabled: o, className: t, ariaLabel: r, children: s, onClick: n }, a) => /* @__PURE__ */ m(
    "button",
    {
      ref: a,
      type: "button",
      disabled: o,
      className: c(p.root, t),
      "aria-label": r,
      onClick: n,
      children: s
    }
  )
);
f.displayName = "IconButton";
export {
  f as IconButton
};
